import { NgModule } from '@angular/core';
import { RouterModule, Routes, mapToCanActivate } from '@angular/router';
// Guard
import { AuthGuard } from '@guards/auth.guard';
import { ModuleGuard } from '@guards/module.guard';
import { DefaultRouteGuard } from '@guards/default-route.guard';
import { PermissionGuard } from '@guards/permission.guard';
import { PasswordUpdateGuard } from '@guards/password-update.guard';
import { LoginByTokenGuard } from '@guards/login-by-token.guard';
import { ErrorPathGuard } from '@guards/error-path.guard';
import { SpConfigGuard } from '@guards/sp-config.guard';
import { UserPinGuard } from '@guards/user-pin.guard';
// Models
import { AngularPaths, Module, Permission } from '@models/index.model';
// Components
import { PageNotFoundComponent } from '@pages/page-not-found/page-not-found.component';
import { LoginComponent } from '@pages/login/login.component';
import { PasswordUpdateComponent } from '@pages/login/password-update.component';
import { WebSignComponent } from '@pages/web-sign/web-sign.component';
import { CertificatesComponent } from '@pages/certificates/certificates.component';
import { SetResetUserPinComponent } from '@pages/user-pin/set-reset-user-pin.component';
import { AuthUserPinComponent } from '@pages/index.pages';
import { UserPinRouteGuard } from '@guards/user-pin-route.guard';
import { SsoUserPinGuard } from '@guards/sso-user-pin.guard';

const routes: Routes = [
  {
    path: AngularPaths.LOGIN,
    component: LoginComponent,
    canActivate: mapToCanActivate([DefaultRouteGuard])
  },
  {
    path: AngularPaths.LOGIN_BY_TOKEN + '/:tempToken',
    component: LoginComponent,
    canActivate: mapToCanActivate([LoginByTokenGuard]),
  },
  {
    path: AngularPaths.ERROR + '/:msg',
    component: LoginComponent,
    canActivate: mapToCanActivate([ErrorPathGuard]),
  },
  {
    path: AngularPaths.PASSWORD_UPDATE,
    component: PasswordUpdateComponent,
    canActivate: mapToCanActivate([PasswordUpdateGuard])
  },
  {
    path: AngularPaths.SIGNTRUST,
    component: WebSignComponent,
    canActivate: mapToCanActivate([AuthGuard, ModuleGuard.forModules(Module.WEB_SIGNATURE), PermissionGuard.forPermissions(Permission.WEB_SIGNATURE)])
  },
  {
    path: AngularPaths.SIGN_BY_AGENT + '/:agentConfig',
    component: WebSignComponent,
    canActivate: mapToCanActivate([AuthGuard, ModuleGuard.forModules(Module.WEB_SIGNATURE), PermissionGuard.forPermissions(Permission.WEB_SIGNATURE)])
  },
  {
    path: AngularPaths.SIGNTRUST + '/:spConfig',
    component: WebSignComponent,
    canActivate: mapToCanActivate([SpConfigGuard, AuthGuard, ModuleGuard.forModules(Module.WEB_SIGNATURE), ModuleGuard.forModules(Module.SHAREPOINT), PermissionGuard.forPermissions(Permission.WEB_SIGNATURE), PermissionGuard.forPermissions(Permission.SHAREPOINT)])
  },
  {
    path: AngularPaths.MSAL_LOGOUT,
    component: WebSignComponent,
    canActivate: mapToCanActivate([AuthGuard, ModuleGuard.forModules(Module.WEB_SIGNATURE), ModuleGuard.forModules(Module.SHAREPOINT), PermissionGuard.forPermissions(Permission.WEB_SIGNATURE), PermissionGuard.forPermissions(Permission.SHAREPOINT)])
  },
  {
    path: AngularPaths.CERTIFICATES,
    component: CertificatesComponent,
    canActivate: mapToCanActivate([AuthGuard])
  },
  {
    path: AngularPaths.USER_PIN + '/:userPinConfig',
    component: AuthUserPinComponent,
  },
  {
    path: AngularPaths.USER_PIN,
    component: AuthUserPinComponent,
    canActivate: mapToCanActivate([UserPinRouteGuard]),
  },
  {
    path: AngularPaths.SSO_USER_PIN + '/:tempToken',
    component: AuthUserPinComponent,
    canActivate: mapToCanActivate([SsoUserPinGuard]),
  },
  {
    path: AngularPaths.CONFIG_USER_PIN + '/:userPinConfig',
    component: SetResetUserPinComponent,
    canActivate: mapToCanActivate([UserPinGuard]),
  },
  {
    path: AngularPaths.CONFIG_USER_PIN,
    component: SetResetUserPinComponent,
    canActivate: mapToCanActivate([UserPinRouteGuard]),
  },
  {
    path: AngularPaths.NOT_FOUND,
    component: PageNotFoundComponent,
  },
  {
    path: AngularPaths.MSAL_LOGIN_FAILED,
    component: PageNotFoundComponent, //customizar
  },
  {
    path: '',
    pathMatch: 'full',
    children: [],
    canActivate: mapToCanActivate([DefaultRouteGuard])
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
